import { render, staticRenderFns } from "./VacationCarryOverRequestCommentListItem.vue?vue&type=template&id=68d5e555&"
import script from "./VacationCarryOverRequestCommentListItem.vue?vue&type=script&lang=ts&"
export * from "./VacationCarryOverRequestCommentListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports